export const QUERY_KEYS = {
  me: ['me'] as const,
  sites: ['sites'] as const,
  administrators: ['administrators'] as const,
  administratorMobile: (id: string) => ['administrators', id, 'mobile'] as const,
  administratorMobilePreview: (id: string, mobile: string) =>
    ['administrators', id, 'mobile', 'preview', mobile] as const,
  siteFilterOptions: ['sites', 'include-inactive'] as const,
  transactions: (params: unknown) => ['transactions', params] as const,
  invoice: (id: string, siteId?: string) => ['invoice', id, siteId] as const,
  settlements: (params: unknown) => ['settlements', params] as const,
  payouts: (params: unknown) => ['payouts', params] as const,
  payout: (id: string, gateway: string) => ['payout', id, gateway] as const,
  settlementDay: (date: string, gateway: string, siteId?: string) =>
    ['settlement-day', date, gateway, siteId] as const,
} as const;
